import { render, staticRenderFns } from "./RegisterFormComponent.vue?vue&type=template&id=4da01f6a&scoped=true&"
import script from "./RegisterFormComponent.vue?vue&type=script&lang=ts&"
export * from "./RegisterFormComponent.vue?vue&type=script&lang=ts&"
import style0 from "./RegisterFormComponent.vue?vue&type=style&index=0&id=4da01f6a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4da01f6a",
  null
  
)

export default component.exports